// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"w2-z","disabled":"x2-z","seeAllAnswers":"y2-z"};